import React, { useEffect, useState } from "react";
import axios from "../../../../axios"; // <-- apna axios path
import userImage from "../../../../Images/Margin (1).png";
import bookIcon from "../../../../Images/Overlay.png";
import { Link } from "react-router-dom";
import { FaArrowRightLong, FaUser } from "react-icons/fa6";
import Taskchart from "../../../../componant/Charts/RevenueChart";
import ActivityChart from "../../../../componant/Charts/UserActivityChart";
import {
  FaUsers,
  FaTrophy,
  FaBookOpen,
  FaCrown,
  FaGamepad,
  FaWallet,
  FaMoneyBillWave,
  FaCheckCircle,
  FaClock,
} from "react-icons/fa";

function StartQuizepage() {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("/allData");
        console.log(res.data.result, "all data");

        setDashboardData(res.data.result);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div className="text-center mt-10">Loading...</div>;

  return (
    <div className="lg:py-5 lg:h-full  bg-bgBlue">
      <div className="mx-auto p-5 flex flex-wrap justify-between">
        <div className="w-full flex justify-between items-center mb-2">
          <div className="p-0 flex gap-10 items-center rounded-xl bg-white shadow-2xl w-full">
            <div>
              <img src={userImage} alt="" className="hidden md:block w-56" />
            </div>
          <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-3xl p-6 md:p-8 text-white flex flex-col lg:flex-row lg:justify-between lg:items-center gap-6 shadow-lg">

  {/* Left Content */}
  <div className="text-black max-w-xl">
    <h1 className="text-2xl md:text-3xl font-bold mb-2">
      Welcome Back, Admin 👋
    </h1>

    <p className="opacity-90 text-sm md:text-base">
      Here's what's happening on your platform today.
    </p>

    <Link to="/dash/active-user">
      <button className="mt-4 bg-white text-indigo-600 font-semibold px-5 py-2 rounded-xl hover:scale-105 transition">
        View Users →
      </button>
    </Link>
  </div>

  {/* Activity Card */}
  <div className="bg-white/20 backdrop-blur-lg text-black p-5 md:p-6 rounded-2xl w-full lg:w-[320px] shadow-md">

    <h2 className="text-lg font-semibold mb-4">
      Today's Activity
    </h2>

    <ul className="space-y-3 text-sm">

      <li>
        ✅ {dashboardData?.todayPlanPurchasedUsersCount || 0} Users purchased plans
      </li>

      <li>
        💰 ₹
        {(dashboardData?.todaySuccessAmount || 0) +
          (dashboardData?.todayPendingAmount || 0)}
        {" "} withdrawal requests
      </li>

      <li>
        🎯 {dashboardData?.todayContestUsersCount || 0} contests completed
      </li>

    </ul>

  </div>

</div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6"></div>
          </div>
        </div>
        <div className="mt-6">
          {/* Cards Section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-5 gap-10">
            <DashboardCard
              icon={FaUsers}
              title="Total Users"
              value={dashboardData.usersCount}
              color="bg-indigo-500"
            />

            <DashboardCard
              icon={FaTrophy}
              title="Today New Users"
              value={dashboardData.todayUsersCount}
              color="bg-purple-500"
            />

            <DashboardCard
              icon={FaBookOpen}
              title="Today Contest Join Users"
              value={dashboardData.todayContestJoinsCount}
              color="bg-blue-500"
            />

            <DashboardCard
              icon={FaCrown}
              title="Plan Purchased Users"
              value={dashboardData.planPurchasedUsersCount}
              color="bg-yellow-500"
            />

            <DashboardCard
              icon={FaGamepad}
              title="Contest Played Users"
              value={dashboardData.contestPlayedUsersCount}
              color="bg-pink-500"
            />

            <DashboardCard
              icon={FaWallet}
              title="Total Plan Amount"
              value={`₹ ${dashboardData.totalPlanAmount}`}
              color="bg-emerald-500"
            />

            <DashboardCard
              icon={FaMoneyBillWave}
              title="Total Recharge Amount"
              value={`₹ ${dashboardData.totalRechargeAmount}`}
              color="bg-teal-500"
            />

            <DashboardCard
              icon={FaWallet}
              title="Total Earnings"
              value={`₹ ${dashboardData.totalPlanAmount + dashboardData.totalRechargeAmount}`}
              color="bg-green-500"
            />

            <DashboardCard
              icon={FaCheckCircle}
              title="Withdrawal (Success)"
              value={`₹ ${dashboardData.totalWithdrawalSuccessAmount}`}
              color="bg-green-600"
            />

          <DashboardCard
  icon={FaClock}
  title="Withdrawal (Pending)"
  value={`₹ ${Number(
    dashboardData.totalWithdrawalPendingAmount || 0
  ).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`}
  color="bg-orange-500"
/>
          </div>

          {/* Chart Section */}
          <div className="mt-10 bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
            <Taskchart data={dashboardData} />
            <ActivityChart data={dashboardData} />
          </div>
        </div>
      </div>
    </div>
  );
}

const DashboardCard = ({ icon: Icon, title, value, color }) => {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition duration-300 border border-gray-100">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-500 font-medium">{title}</p>
          <h2 className="text-2xl font-bold mt-2 text-gray-800">{value}</h2>
        </div>

        <div className={`p-4 rounded-xl ${color} text-white text-xl`}>
          <Icon />
        </div>
      </div>
    </div>
  );
};
export default StartQuizepage;
